import { compose, curry, defaultTo, filter, find, map, pathOr, prop } from 'ramda';

import { SelectOption } from '@gef-ui/components/atoms/Select';

export const getCodelistByName = (codelistName) => compose(pathOr([], ['codelists', codelistName, 'values']));

export const getCodelistObjectById = curry((id, codelist) =>
	compose(
		defaultTo({}),
		find((t) => parseInt(t.id, 10) === id),
	)(codelist),
);

/**
 *
 * utility for getting values from codelist according ID
 *
 * @param id
 * @param codelist
 * @param prop
 * @param propsId
 * @returns prop value
 */
export const getCodelistPropById = curry((id, codelist = [], property = 'description', propsId = 'id') =>
	compose(
		defaultTo(''),
		prop(property),
		defaultTo({}),
		find((t) => parseInt(t[propsId], 10) === Number(id)),
	)(codelist),
);

/**
 * @param id - value of 'propsId'
 * @param codelist - codelist itself
 * @param propsId - prop according filter codelist
 */

export const getIdsByPropValue = curry((codelist = [], property = 'stateType', propertyValue = '') =>
	compose(
		map((t) => Number(prop('id', t))),
		filter((t) => t[property] === propertyValue),
	)(codelist),
);

export const filterCodelistById = curry((id, codelist, propsId = 'id') =>
	filter((t) => parseInt(t[propsId], 10) === id, codelist),
);
/**
 *
 * @param fieldName
 * @returns {function(): function(*)}
 */

const createCodelist = (fieldName) => () => (items) => {
	// endpoints return values without description - we don't want them
	const filteredItems = items.filter((item) => item[fieldName]);

	return filteredItems.map((item) => {
		return <SelectOption key={item.id} value={item.id} label={item[fieldName]} />;
	});
};
/**
 *
 * @param fieldName
 * @returns {function(): function(*)}
 */

const createSortedCodelist = (fieldName) => (type) => (items) => {
	// endpoints return values without description - we don't want them
	const filteredItems = items.filter((item) => item[fieldName]);

	const sortedFilteredItems = filteredItems.sort((a, b) => {
		const first = a[fieldName].toUpperCase();
		const second = b[fieldName].toUpperCase();
		return first.localeCompare(second);
	});

	return sortedFilteredItems.map((item) => {
		let result;
		switch (type) {
			case 'agencies':
				result = 'agencyId';
				break;
			case 'regions':
				result = 'regionId';
				break;
			case 'agenciesGroupName':
				result = 'groupName';
				break;
			default:
				result = 'id';
		}
		return <SelectOption key={item.id} value={item[result]} label={item[fieldName]} />;
	});
};

/**
 * Get codelist items with short description
 */
export const codelistShortOptions = createCodelist('shortDescription');

/**
 * Get codelist items with full description
 */
export const codelistOptions = createCodelist('description');

/**
 * Get sorted codelist items with full description
 */
export const codelistSortedOptions = createSortedCodelist('description');

// This is temporary solution - should be done on BE
export const createOptionsForRegions = () => () =>
	compose(
		codelistOptions(),
		filter((item) => (item.company === 'CP' ? item.id.length === 3 : true)),
	);
